import { useEffect, useRef, useState } from 'react';
import images from '../../assets/images';
import './ExamGuideContainer.scss';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import MaterialActionsOverlay from '../ActionsOverlay/MaterialActionsOverlay';
import { BY_ADMIN, getMenuItems } from '../../utils/helper';
import { useAppSelector } from '../../redux/app/hooks';
import { SCHOOL_ADMIN, STUDENT_ROLE } from '../../utils/constants';
import { Tooltip } from '@mui/material';
import { SharedBy } from '../../utils/interface';
interface GuidesData {
   filename: string;
   filepath: string;
   filesize: number;
   isclassroom: boolean;
   coverimagepath: string;
   authorname: string;
   fileId: string;
   sharedBy ? : SharedBy | null
}
interface ExamGuideContainerProps {
   handleOpenFile: (guidesData: GuidesData) => void;
   guidesData: [GuidesData] | undefined;
   handleMaterialActions: (data:GuidesData,action:string) => void;
   from: string;
}

const ExamGuideContainer: React.FC<ExamGuideContainerProps> = ({ from, handleOpenFile, guidesData, handleMaterialActions }) => {
   const { greyMoreIcon, guideDefaultImage, ShareIcon, ShareGif, RightClickArrow, DeleteGif } = images;
   const baseUrl = process.env.REACT_APP_FRONTEND_URL;
   const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
   const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
   const [openOverlay, setOpenOverlay] = useState<boolean>(false);
   const [selectedMaterial, setSelectedMaterial] = useState<GuidesData | null>(null);
   const [action, setAction] = useState<string>('');
   const role = useAppSelector((state) => state.auth.role);
   const guideTitleRef = useRef<HTMLDivElement | null>(null);
   const [isOverflow, setIsOverflow] = useState(false);
   const confirmationMessageShare = role === SCHOOL_ADMIN 
                                    ?  "Are you sure you want to Share this file with your Class & Teacher?"
                                    : "Are you sure you want to Share this file with your Class?"
   const confirmationMessageDelete = role === SCHOOL_ADMIN ?  "Are you sure you want to Delete this file?": "Are you sure you want to Delete this file with your Class?"


     //To check the container is overflow
  const checkOverflow = () => {
   if (guideTitleRef.current) {
     setIsOverflow(guideTitleRef.current.scrollHeight > guideTitleRef.current.clientHeight);
   }
 };

   // click yes button in confirmation popup
   const onYesButtonClick = () => {
      setOpenConfirmationPopup(false);
      if (selectedMaterial) {
         handleMaterialActions(selectedMaterial, action)
      }
   }

   // click no button in confirmation popup
   const onNoButtonClick = () => {
      setOpenConfirmationPopup(false);
   }

   const handleClickMoreIcon = (event: React.MouseEvent<HTMLElement>, guideData: GuidesData | undefined) => {
      event.stopPropagation(); // Stop propagation to prevent triggering parent click
      if (guideData) {
         setSelectedMaterial(guideData);
         if (guideData?.isclassroom === true) {
            setAnchorEl(event.currentTarget);
            setOpenOverlay(true);
         } else if (guideData?.isclassroom === false) {
            setAction('share');
            setOpenConfirmationPopup(true);
         }
      }
   };

   const handleCloseActions = () => {
      setAnchorEl(null);
      setOpenOverlay(false);
   };

   const menuItems = handleMaterialActions ? getMenuItems(handleCloseActions, handleMaterialActions, setOpenConfirmationPopup, setAction, selectedMaterial, from):[];

       //To check overflow in resize 
       useEffect(() => {
         window.addEventListener('resize', checkOverflow);
     
         return () => {
           window.removeEventListener('resize', checkOverflow);
         };
       }, []);
     
         useEffect(() => {
            checkOverflow();
          }, [guidesData]);

   return (
      <div className={`${guidesData && guidesData?.length > 0 ? role === STUDENT_ROLE ? 'examGuideContainerStudent' : 'examGuideContainer' : 'noData'}`}>
         {guidesData && guidesData.length > 0 ? (
            guidesData.map((guide: GuidesData) => (
               <div className={role === STUDENT_ROLE ? "student-exam-guide":"exam-guide"} key={guide.filepath} onClick={() => handleOpenFile(guide)}>
                  <div className='guideContentCtn'>
                     <img src={guide?.coverimagepath ? baseUrl + guide?.coverimagepath : guideDefaultImage} alt="guide-profile" className='guideProfile' />
                     <div className='guideNameCtn'>
                        <Tooltip title={guide?.filename} disableHoverListener={!isOverflow}>
                        <p className='guideTitle' ref={guideTitleRef} onMouseEnter={checkOverflow}>{guide?.filename}</p>
                        </Tooltip>
                       <div className='guide-container'> 
                        <p className='guideAuthor'>{guide?.authorname}</p> 
                        { (guide.sharedBy && role === STUDENT_ROLE) &&  <div className='Admin-label'>{BY_ADMIN}</div>}
                       </div>
                     </div>
                  </div>
                  {role === STUDENT_ROLE ?
                  <div className='guideActionsCtn'>
                        <img src={RightClickArrow} alt="action" /> 
                  </div>  : guide.sharedBy ?
                  <div className='guideActionsCtn' onClick={(event) => handleClickMoreIcon(event, guide)} >
                     <div className='Admin-label'>{BY_ADMIN}</div>
                  </div>  :
                  <div className='guideActionsCtn' onClick={(event) => handleClickMoreIcon(event, guide)} >
                     {guide?.isclassroom ?
                        <img src={greyMoreIcon} alt="action" className='moreIcon' /> :
                        <img src={ShareIcon} alt="share"  className='shareIcon'/>
                     } 
                  </div>}
               </div>
            ))
         ) : (
            <div className='noDataFoundStyle'>No data found</div>
         )}
         <MaterialActionsOverlay
            anchorEl={anchorEl}
            open={openOverlay}
            handleClose={handleCloseActions}
            menuItems={menuItems}
            actionsHeight={'115px'}
            position="left"
         />
         <ConfirmationPopup
            open={openConfirmationPopup}
            message={action==="share" ?  confirmationMessageShare: confirmationMessageDelete}
            gifData={action==="share" ? ShareGif: DeleteGif }
            yesButtonFunctionality={onYesButtonClick}
            noButtonFunctionality={onNoButtonClick}
            messageWidth={'210px'}
         />
      </div>
   )
}

export default ExamGuideContainer;
